import { Buffer } from 'buffer';
import browserProcess from 'process/browser';

window.global ||= window;

window.Buffer = window.Buffer || Buffer;
window.process = window.process || browserProcess;
